module.exports = __webpack_public_path__ + "img/北海公园.035a6c4f.png";